export const PLUGIN_NAME = 'Designer';
